"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importDefault(require("react"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const theme_1 = __importDefault(require("../styles/theme"));
const Tooltip = (_a) => {
    var { text, children, placement = 'top', style, className } = _a, commonProps = __rest(_a, ["text", "children", "placement", "style", "className"]);
    const useStyles = makeStyles_1.default({
        tooltip: Object.assign({ border: `1px solid ${theme_1.default.colors.textLight}`, backgroundColor: theme_1.default.colors.white, color: theme_1.default.colors.textDefault, fontWeight: 'normal', fontSize: '0.9rem', padding: '1rem', borderRadius: '10px', textAlign: 'center' }, style),
        arrow: {
            '&:before': {
                border: `1px solid ${theme_1.default.colors.textLight}`,
            },
            color: theme_1.default.colors.white,
        },
    });
    const classes = useStyles();
    return (react_1.default.createElement(Tooltip_1.default, { title: text, arrow: true, placement: placement, classes: {
            arrow: classes.arrow,
            tooltip: className
                ? `${className} ${classes.tooltip}`
                : classes.tooltip,
        }, PopperProps: commonProps },
        react_1.default.createElement("div", null, children)));
};
exports.Tooltip = Tooltip;
exports.default = exports.Tooltip;
